import { BLOB_BASE_URL } from '../auth';

/**
 * Resolve a relative blob URL to an absolute URL.
 * Pass-through for already-absolute http(s) URLs.
 */
export function resolveUrl(url: string | null | undefined): string | undefined {
    if (!url) return undefined;
    if (url.startsWith('http')) return url;
    return `${BLOB_BASE_URL}/${url.replace(/^\//, '')}`;
}
